import React from 'react';
import { Heart } from 'lucide-react';
import { favoritesService } from '../../lib/favorites/favoritesService';
import { analyticsService } from '../../lib/analytics/analyticsService';
import { Toast } from './Toast';

interface FavoriteButtonProps {
  itemId: string;
  isFavorite: boolean;
  onToggle: (isFavorite: boolean) => void;
  config: any;
  translations: Record<string, Record<string, string>>;
}

export const FavoriteButton: React.FC<FavoriteButtonProps> = ({
  itemId,
  isFavorite,
  onToggle,
  config,
  translations
}) => {
  const [showToast, setShowToast] = React.useState(false);
  const [toastMessage, setToastMessage] = React.useState('');

  const handleToggle = (e: React.MouseEvent) => {
    e.stopPropagation();

    const newState = !isFavorite;
    onToggle(newState);

    // Afficher le toast approprié
    const messageKey = newState ? 'added_to_favorites' : 'removed_from_favorites';
    const message = translations[messageKey]?.fr || messageKey;
    setToastMessage(message);
    setShowToast(true);

    // Tracker l'événement
    analyticsService.trackEvent({
      event_type: 'interaction',
      event_name: newState ? 'add_favorite' : 'remove_favorite',
      event_data: { item_id: itemId }
    });
  };

  return (
    <>
      <button
        onClick={handleToggle}
        className="absolute top-0 left-0 w-12 h-12 flex items-center justify-center transition-opacity hover:opacity-80 z-10"
        style={{ 
          backgroundColor: config['major-color'],
          borderTopLeftRadius: config.border_radius,
          borderBottomRightRadius: config.border_radius
        }}
        aria-label={isFavorite ? 'Retirer des favoris' : 'Ajouter aux favoris'}
      >
        <Heart
          size={24}
          className="text-white"
          fill={isFavorite ? 'currentColor' : 'none'}
        />
      </button>

      {showToast && (
        <Toast
          message={toastMessage}
          type="success"
          onClose={() => setShowToast(false)}
          duration={3000}
          icon={<Heart size={18} className="text-white" fill="currentColor" />}
        />
      )}
    </>
  );
};